export const DEFAULT_LEGEND_WIDTH = {
  value: 20,
  type: 'PERCENT'
};